import { Enrolment } from '@/models/enrolment';

import { Event } from './event';

export class EnrolmentsMovedToHistoryEvent extends Event<Enrolment[]> {}
